<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { resCode } from 'api/config'
import { setStorage, getStorage } from 'api/user'
import { getVersion } from 'api/baseapi'
export default {
  name: 'App',
  created() {
    const version = getStorage('version')
    if (!version) {
      getVersion().then(res => {
        if (res.code === resCode.ERR_OK) {
          setStorage('version', res.resdata)
          // setStorage('version', "v3.0.6")
        }
      })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue